import { Link } from 'react-router-dom';
import React, { useMemo } from 'react';
import { ifElseKeyValue, formatDate } from '@/shared/helpers'

const RenderActions = ({ row }) => {
  return (
    <>
      <span>
        <Link to={`/program/${row.original.program_id}/user/view/${row.original.user_id}`}>{row.original.participant_email}</Link>
      </span>
    </>
  )
}
export const TABLE_COLUMNS = [

  // {
  //   Header: "First Name",
  //   accessor: "first_name",
  // },
  // {
  //   Header: "Last Name",
  //   accessor: "last_name",
  // },
  // {
  //   Header: "Email",
  //   accessor: "email",
  // },
  {
    Header: "Program Name",
    accessor: "program_name",
  },
  {
    Header: "Program ID",
    accessor: "program_id",
  },
  // {
  //   Header: "Phone",
  //   accessor: "phone",
  //   // Cell: ({ row }) => <RenderActions row={row} />
  // },
  {
    Header: "Date Created",
    accessor: "date_created",
    Cell: ({ row, value }) => { return formatDate(value); },
  },
  {
    Header: "Application type",
    accessor: "application_type",
  },
  {
    Header: "Trial",
    accessor: "trial",
  },
  {
    Header: "Cancelled",
    accessor: "cancelled",
  },
  {
    Header: "Cancelled date",
    accessor: "cancelled_date",
    Cell: ({ value }) => {
      if (!value || isNaN(new Date(value))) {
        return '-';
      }
      return formatDate(value);
    }
  },
  {
    Header: "Subscription Amount",
    accessor: "subscription_amount",
    Cell: ({ value }) => {
      if (!value || isNaN(new Date(value))) {
        return '-';
      }
      return <span>{`${parseFloat(value).toFixed(2)}`}</span>;
    }
  },
  {
    Header: "First Paid Subscription Date",
    accessor: "first_paid_subscription_date",
    Cell: ({ value }) => {
      if (!value || isNaN(new Date(value))) {
        return '-';
      }
      return formatDate(value);
    }
  },
  {
    Header: "Is Subscription Active",
    accessor: "is_subscription_active",
  },
  {
    Header: "Subscription Renew Date",
    accessor: "subscription_renew_date",
    Cell: ({ value }) => {
      if (!value || isNaN(new Date(value))) {
        return '-';
      }
      return formatDate(value);
    }
  },
  // {
  //   Header: "Funds Added",
  //   accessor: "funds_added",
  //   Cell: ({ value }) => { return <span>{`${parseFloat(value).toFixed(2)}`}</span>; }
  // },
  // {
  //   Header: "Last Login",
  //   accessor: "last_login",
  //   Cell: ({ value }) => {
  //     if (!value || isNaN(new Date(value))) {
  //       return '-';
  //     }
  //     return formatDate(value);
  //   }
  // },


]

